export default __webpack_public_path__ + "static/media/outro-collage.2fed236d.mp3";